import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getDashboard({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get('dashboard/dashboard', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD, r.data)
    return r.data
  },
  async getClientReview({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getClientReview', () =>
      http.get('dashboard/clientReview', {
        params: options
      })
    )
    commit(types.SET_CLIENTREVIEW, r.data)
    return r.data
  },
  async getClientInspections({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getClientInspections', () =>
      http.get('dashboard/clientReview', {
        params: options
      })
    )
    commit(types.SET_CLIENTINSPECTIONS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js